/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-10-26 17:41:58
 * @LastEditors: yinj
 * @LastEditTime: 2021-01-21 17:14:51
 */
// import { BasicLayout } from '@/components/layouts';
import Exception from '@/views/Exception.vue';
import ExceptionImage403 from '@/assets/exception_403.png';
import ExceptionImage404 from '@/assets/exception_404.png';
import ExceptionImage500 from '@/assets/exception_500.png';
import schemeShare from '@/router/modules/scheme/share';
import wenjuanPreview from '@/router/modules/wenjuan/preview';

export default [
  schemeShare, wenjuanPreview,
  {
    path: '/',
    redirect: '/404',
  },
  // {
  //   path: '/test',
  //   component: BasicLayout,
  //   redirectToChild: true,
  //   hideChildrenInMenu: true,
  //   meta: {
  //     title: '首页',
  //   },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Home',
  //       component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  //     },
  //   ],
  // },
  {
    path: '/403',
    name: 'Exception.403',
    component: Exception,
    hiddenInMenu: true,
    props: {
      sourceData: {
        imageUrl: ExceptionImage500,
        type: 403,
        title: '抱歉，你无权访问该页面',
        showHomeButton: true,
      },
    },
  },
  {
    path: '/404',
    name: 'Exception.404',
    component: Exception,
    hiddenInMenu: true,
    props: {
      sourceData: {
        imageUrl: ExceptionImage404,
        type: 404,
        title: '抱歉，你访问的页面找不到了',
        showHomeButton: true,
      },
    },
  },
  {
    path: '/500',
    name: 'Exception.500',
    component: Exception,
    hiddenInMenu: true,
    props: {
      sourceData: {
        imageUrl: ExceptionImage403,
        type: 500,
        title: '抱歉，服务器出错了',
        showHomeButton: true,
      },
    },
  },
];
